import { createFileRoute } from '@tanstack/react-router';
import { RelatorioVendaRelacaoVendas } from '@/features/relatorio/page/venda/relacao-vendas/RelatorioVendaRelacaoVendas';

export const Route = createFileRoute('/a/relatorio/venda/relacao-vendas')({
    component: RelatorioVendaRelacaoVendas,
});
